
const ajax_url = ajaxurl['ajax_url'];

window.addEventListener("DOMContentLoaded", () => {
	const containers = document.querySelectorAll('.wp-block-welko-latest-newsletters');
	containers.forEach((container) => {
		//Déclaration du loadmore
		declare_welko_latest_newsletters_loadmore_newsletter(container);
		//Déclaration du slider
		declare_welko_latest_newsletters_swiper(container);
	});
});

//SLIDER
function declare_welko_latest_newsletters_swiper(container) {
	let swiper = container.querySelector('.wp-block-welko-latest-newsletters__list .swiper');
	if (swiper !== null) {
		let swiper_name = ".swiper_" + swiper.getAttribute('data-id');
		let nb_slide = parseInt(swiper.getAttribute('data-nb-slide'));
		let autoSlide = (/true/).test(swiper.getAttribute('data-auto-slide'));

		const swiperInstance = new Swiper(swiper_name, {
			watchSlidesProgress: true,
			spaceBetween: 30,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
			},
			autoplay: autoSlide,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				577: {
					slidesPerView: 2,
				},
				767: {
					slidesPerView: 3,
				},
				992: {
					slidesPerView: nb_slide,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
			},
		});
	}
}

//LOADMORE
function declare_welko_latest_newsletters_loadmore_newsletter(container) {
	const loadmores = container.querySelectorAll('.wp-block-welko-latest-newsletters__loadmore');
	const postListContainer = container.querySelector('.wp-block-welko-latest-newsletters__list');
	if (loadmores.length && loadmores.length > 0) {
		loadmores.forEach((loadmore) => {
			loadmore.addnewsletterListener('click', function () {
				welko_latest_newsletters_loadmore(postListContainer);
			});
		});
	}
}

function welko_latest_newsletters_loadmore(postListContainer) {

	//Container du loadmore/pagination
	var postLoadmore = (postListContainer.nextElementSibling.classList.contains('wp-block-welko-latest-newsletters__loadmore')) ? postListContainer.nextElementSibling : false;

	//Données à envoyer
	let _data = {
		action: 'welko_latest_newsletters_loadmore',
		...postListContainer.dataset
	};

	fetch(ajax_url, {
		method: 'POST',
		body: (new URLSearchParams(_data)).toString(),
		headers: {
			'Content-type': 'application/x-www-form-urlencoded'
		}
	}).then(response => {
		if (!response.ok) throw new Error("Erreur réseau");
		return response.json();
	}).then(data => {
		// Crée un document à partir du HTML reçu
		let parser = new DOMParser();
		let doc = parser.parseFromString(data.html, 'text/html');

		// Récupère tous les éléments enfants du <body> du HTML reçu
		let elements = doc.body.children;

		// Insère chaque élément dans le conteneur
		Array.from(elements).forEach(el => {
			postListContainer.append(el);
		});

		//Mise à jour de l'offset
		let posts_per_page = postListContainer.getAttribute('data-posts_per_page');
		let offset = postListContainer.getAttribute('data-offset');
		let new_offset = parseInt(offset) + parseInt(posts_per_page);
		postListContainer.setAttribute("data-offset", new_offset);

		//Cache le loadmore caché si plus de post à afficher
		let post_count = postListContainer.getAttribute('data-post_count');
		if (parseInt(new_offset) >= parseInt(post_count)) {
			postLoadmore.style.display = "none";
		}
	});
}

